import { error } from "@sveltejs/kit";
import { POPULAR_NUMBERS } from "../../../../../popular";
import type { PageLoad } from "./$types";

export const load: PageLoad = ({ params }) => {
  const res = POPULAR_NUMBERS[params.country.toUpperCase()]?.find(({ code }) => code === params.code);
  if (!res) {
    return error(404);
  }

  return {
    number: res.number
  };
}
